import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Tooltip } from 'react-tooltip';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { Button, Tab, Tabs } from 'react-bootstrap';
import ApplyLeaveModal from './ApplyLeaveModal';
import Select from 'react-select'
import { IoInformationCircleOutline } from 'react-icons/io5';
import AttendanceModal from './AttendanceModal';
import { finYearListTodo } from '../../LMS_Redux/LMS_Slices/Hr/FinYearList';
import { attendanceStatusListTodo } from '../../LMS_Redux/LMS_Slices/Hr/AttendanceStatusList';
import { leaveStatusListTodo } from '../../LMS_Redux/LMS_Slices/Hr/LeaveStatusList';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import { attendanceHistoryListTodo } from '../../LMS_Redux/LMS_Slices/Hr/AttendanceHistoryList';

export default function AttendanceList() {

    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(true)
    const [attendanceLoading, setAttendanceLoading] = useState(true)
    const [showLeave, setShowLeave] = useState(false)
    const [showAttendance, setShowAttendance] = useState(false)
    const [key, setKey] = useState('attendance')
    const [currentYear, setCurrentYear] = useState(null)
    const dispatch = useDispatch()
    const year = useSelector(state => state?.finYearList?.data?.data)
    const attendance = useSelector(state => state?.attendanceStatusList?.data?.data)
    const leave = useSelector(state => state?.leaveStatusList?.data?.data)
    // console.log(leave)

    const year_option = year?.map(val => (
        { value: val?.vfin_year_name, label: val?.vfin_year_name }
    ))

    const apply_leave = () => setShowLeave(true);

    const show_attendance = (val) => {
        setAttendanceLoading(true);
        setShowAttendance(true);
        dispatch(attendanceHistoryListTodo({ month: val?.imonth_id, fy: localStorage.getItem('fy') })).finally(() => setAttendanceLoading(false))
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'MONTH',
            field: 'vmonth_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TOTAL ATTENDANCE',
            field: 'present_days',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TOTAL LEAVES',
            field: 'leave_taken',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REMAINING LEAVES',
            field: 'leave_left',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline size={20} className='eye'
                        onClick={() => show_attendance(params?.data)}
                        data-tooltip-id='details'
                        data-tooltip-content="View Attendance!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />

                </div>,
            autoHeight: true,
        }
    ]);

    const [columnDefsLeave, setColumnDefsLeave] = useState([
        {
            headerName: 'LEAVE TYPE',
            field: 'vleave_type',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'SUB TYPE',
            field: 'vleave_sub_type',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'FROM DATE',
            field: 'from_date',
            cellRenderer: (params) => params?.value && moment(params?.value).format('DD/MM/YYYY'),
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TO DATE',
            field: 'to_date',
            cellRenderer: (params) => params?.value && moment(params?.value).format('DD/MM/YYYY'),
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REMARK',
            field: 'vremark',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'capprove_status',
            cellRenderer: params => <span className={params.value === 'A' ? 'badge text-bg-success' : params.value === 'P' ? 'badge text-bg-warning' : params.value === 'R' ? 'badge text-bg-danger' : 'badge text-bg-secondary'} style={{ textTransform: 'capitalize' }}>{params.value === 'A' ? 'Approved' : params.value === 'P' ? 'Pending' : params.value === 'R' ? 'Reject' : params?.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
    ]);

    const change_fin_year = (year) => {
        setLoading(true);

        Promise.all([
            dispatch(attendanceStatusListTodo({ year: year })),
            dispatch(leaveStatusListTodo({ year: year }))
        ]).finally(() => setLoading(false));
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await dispatch(finYearListTodo());
                const data = res?.payload?.data?.[0];

                if (data?.vfin_year_name) {
                    setCurrentYear({ value: data.vfin_year_name, label: data.vfin_year_name });
                    localStorage.setItem('fy', data.vfin_year_name)

                    await Promise.all([
                        dispatch(attendanceStatusListTodo({ year: data.vfin_year_name })),
                        dispatch(leaveStatusListTodo({ year: data.vfin_year_name }))
                    ]);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header row'>
                    <div className="col-md-8">
                        <span className='icon2'>Attendance List</span>
                    </div>

                    <div className="col-12 col-md-4">
                        <div className="d-flex align-items-center justify-content-between">
                            <Button variant="primary" onClick={apply_leave}>
                                Apply Leave
                            </Button>

                            <Select
                                closeMenuOnSelect={true}
                                options={year_option}
                                value={currentYear ?? null}
                                name='leave_type'
                                onChange={(option) => {
                                    setCurrentYear(option);
                                    change_fin_year(option?.value);
                                    localStorage.setItem('fy', option?.value)
                                }}
                                placeholder=""
                                classNamePrefix="select"
                            />
                        </div>
                    </div>
                </div>

                <Tabs
                    activeKey={key}
                    onSelect={(k) => {
                        setKey(k);
                    }}
                    id="justify-tab-example"
                    className="piils_btn mb-3"
                    justify
                >
                    <Tab eventKey="attendance" title="Attendance" disabled={loading}>
                        {loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {attendance?.length ?
                                    <DataTables
                                        rowData={attendance}
                                        columnDefs={columnDefs}
                                        height={'55vh'}
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Attendance List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>

                    <Tab eventKey="leave" title="Leaves" disabled={loading}>
                        {loading ?
                            <div className='wrapper-admin'>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <>
                                {leave?.length ?
                                    <DataTables
                                        rowData={leave}
                                        columnDefs={columnDefsLeave}
                                        height={'55vh'}
                                    />
                                    :
                                    <div className='wrapper-admin'>
                                        <div className='text-center'>
                                            <h5>Leave List Not Found</h5>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </Tab>

                </Tabs>
            </div>

            <ApplyLeaveModal showLeave={showLeave} setShowLeave={setShowLeave} setBool={setBool} bool={bool} />
            <AttendanceModal showAttendance={showAttendance} setShowAttendance={setShowAttendance} attendanceLoading={attendanceLoading} />

            <ToastContainer />
        </>
    );
}